import { Box, Button, Typography } from '@mui/material';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const VerifyAccount = () => {
  const navigate = useNavigate();

  const { email } = useParams();

  const checkIfEmailRegex = (email: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  if (!checkIfEmailRegex(email as string)) {
    return <Navigate to={'/'} />;
  }

  return (
    <Box
      sx={{
        maxWidth: '100%',
        width: '100%',
        display: 'flex',
        padding: '20px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <form
        action=''
        style={{
          maxWidth: '472px',
          width: '100%',
        }}
      >
        <Box
          bgcolor={'#fff'}
          display={'flex'}
          flexDirection={'column'}
          p={'24px'}
          sx={{ boxShadow: '0px 2px 20px  rgba(29, 49, 55, 0.12)' }}
          borderRadius={'4px'}
          gap={'24px'}
        >
          <Typography variant='h1'>Confirm your account</Typography>

          <>
            <Typography
              color={'#736977'}
              fontSize={'14px'}
              fontWeight={'500'}
              lineHeight={'17px'}
            >
              An email with the verification link has been sent to{' '}
              <span style={{ color: '#3293DB' }}>{email}</span>
            </Typography>
            <Typography
              color={'#736977'}
              fontSize={'14px'}
              fontWeight={'500'}
              lineHeight={'17px'}
            >
              Please check your inbox and click on the link to verify your K2
              account.
            </Typography>
            <Button
              sx={{
                background: '#3293DB',
                color: '#fff',
                maxWidth: '100%',
                boxShadow: 'unset',
                fontSize: '14px',
                lineHeight: '17px',
              }}
              onClick={() => navigate('/')}
              variant='contained'
            >
              Return to Log in
            </Button>
          </>
        </Box>
      </form>
    </Box>
  );
};

export default VerifyAccount;
